export const mandatoryAzureDomains = [
  "actionsustainability.com",
  "scottishpower.com",
  "Biovent.es",
  "Biovent.net",
  "Econquense.com",
  "Eee-mancha.com",
  "Grupoiberdrola.i-de.es",
  "Ibdl.com",
  "Ibediv.com",
  "Ibediv.es",
  "Iberdrola.com",
  "Iberdrola.com.au",
  "Iberdrola.com.br",
  "Iberdrola.com.mx",
  "Iberdrola.eu",
  "Iberinco.com",
  "SPCommercialEnergy.com",
  "anselmoleon.es",
  "cajajuanurrutia.es",
  "carbon2nature.earth",
  "ciberdrola.com",
  "clientescurenergia.es",
  "clientesiberdrola.es",
  "clientesiberdrola.pt",
  "clientiberdrola.it",
  "clientsiberdrola.fr",
  "contactiberdrola.ie",
  "curenergia.es",
  "dataserve-uk.com",
  "educaclima.com",
  "globalgreenemployment.com",
  "i-de.es",
  "ibdinmobiliaria.com",
  "iberdrola.de",
  "iberdrola.es",
  "iberdrola.fr",
  "iberdrola.gr",
  "iberdrola.ie",
  "iberdrola.it",
  "iberdrola.jp",
  "iberdrola.pl",
  "iberdrola.pt",
  "iberdrolacur.es",
  "iberdrolaintl.com",
  "iberdrolaireland.ie",
  "iberdrolamusic.com",
  "iberdrolarenewables.com",
  "iberdrolarenewables.es",
  "iberdrolarenovables.com",
  "iberdrolarenovables.es",
  "klienteniberdrola.de",
  "manweb.co.uk",
  "marramwind.com",
  "movingforclimatenow.org",
  "patrocinios.iberdrola.com",
  "plandepensionesiberdrola.es",
  "powerwise.org.uk",
  "pysco.es",
  "scottishpower.co.uk",
  "scottishpower.com",
  "scottishpowerpipeband.com",
  "sitetrackeribd.es",
  "spenergynetworks.co.uk",
  "spenergynetworks.com",
  "spenergynetworkscrm.co.uk",
  "sppowersystems.co.uk",
  "sppowersystems.com",
  "torreiberdrola.com",
  "union-energy.co.uk",
];
